<template>
    <div class="preview">
        <audio id="player" :src="this.mediaPath()" :type="'audio/' + this.extension" preload="metadata" @timeupdate="displayDuration"></audio>
        <div  class='audio__container'>
            <div class="audio_thumb">
            <img src='../../assets/audio_thumb.svg'>
            </div>

            <div class="player">
                <div class="artist_details">
                    <p class="audio_text title">{{ this.attachments[0]['title'] }}</p>
                    <p class="audio_text artist">{{ this.attachments[0]['artist'] }}</p>
                    <p class="audio_text duration" id="duration">{{ this.audioDuration }}</p>
                </div>

                <div class="player-actions"> 
                    <button class="play-btn" @click="audioPlayerClicked">
                        <img v-if="!this.isPlaying" src="../../assets/audio_play--btn.svg">
                        <img v-if="this.isPlaying" src="../../assets/pause.svg">
                    </button>
                    <input type="range" id="seek-slider" max="" value="0">
                </div>
                
                <div class="timer">
                    <span id="current-time" class="audio_text time">{{ this.currentTime }}</span>
                    <span class="audio_text time">-<span id="id_remaining_time" class="audio_text time">{{ this.remainingTime }}</span></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import jQuery from "jquery";
import {
  buildAttachmentURL,
} from "../../../../helpers/assets";
import { convertMilliSecondsToIsoFormat } from "../../../../helpers/formatters.js";
import ReRenderer from "../../mixins/re-renderer.vue";

export default {
    name: "AudioSlider",
    props: [
        "slideID",
        "postID",
        "attachments",
        "attachmentID",
        "extension",
        "hash",
        "hls_path",
        "thumbExtension",
        "thumbHash",
    ],
    mixins: [ReRenderer],
    data() {
        return {
            reRenderCssSelectors: [
              {
                jquerySelectors: ".preview",
                properties: [
                  {
                    propertyName: "height",
                    propertyValue: this.getWindowHeightInPx,
                    isCallBack: true,
                  },
                ],
              },
            ],
            isPlaying: false,
            raf: null,
            playerContainer: null,
            player: null,
            seekSlider: null,
            audioDuration: "00:00",
            currentTime: "00:00",
            remainingTime: this.audioDuration,
        }
    },
    computed: {
      getAudioDuration(){
        return  this.audioDuration
      },
      getRemainingTime(){
        return this.remainingTime
      }
    }, 
    methods: {
      handleMediaSessionState() {
        //https://developer.mozilla.org/en-US/docs/Web/API/Media_Session_API UHV-17665
        navigator.mediaSession.setActionHandler("play", () => {
          this.player[0].play();
          this.isPlaying = true
        });
        navigator.mediaSession.setActionHandler("pause", () => {
          this.player[0].pause();
          this.isPlaying = false;
        });
        navigator.mediaSession.setActionHandler("stop", () => {
          this.player[0].currentTime = 0;
          this.player[0].pause();
          this.isPlaying = false;
          this.displayDuration();
        });
      },
      initializePlayer(){
        this.playerContainer = jQuery('.preview');
        this.player = jQuery('#player');
        
        if (this.player[0].readyState > 0) {
            this.beforeClicked();
            this.setSliderMax();
            this.displayBufferedAmount();
        } else {
            this.player.on('loadedmetadata', () => {
                this.beforeClicked();
                this.setSliderMax();
                this.displayBufferedAmount();
            });
        }
      },
      setSeekListers(){
          this.seekSlider = jQuery('#seek-slider')
          // Slider Listeners
          this.seekSlider.on('input', () => {
             this.showBufferedProgress();
             this.animateSlider();
          });
          this.seekSlider.on('change', () => {
           this.updatePlayerVal()
          });
          this.seekSlider.on('timeupdate', () => {
           this.updatePlayerVal()
          });

      },
      setAudioListers(){
          // Audio Player Listeners
          this.player.on('timeupdate', () => { 
            this.updateSeekTime(); 
            this.whilePlaying()
          });
          this.player.on('progress', () => {
           this.displayBufferedAmount()
          });
          this.player.on('ended', () => {
            this.isPlaying = false;
          });

      },
        mediaPath() {
            return buildAttachmentURL(
                this.postID,
                this.attachmentID,
                this.extension,
                this.hash
            );
        },
        beforeClicked() {
            this.audioDuration = convertMilliSecondsToIsoFormat(this.player[0].duration);
            this.remainingTime = convertMilliSecondsToIsoFormat(this.player[0].duration);
        },
        setSliderMax() {
            this.seekSliderValue  = this.seekSlider[0].value = Math.floor(this.player[0].currentTime);
            this.seekSlider[0].max = Math.floor(this.player[0].duration);
        },
        showBufferedProgress() {
            this.playerContainer.css('--seek-before-width', this.seekSlider[0].value / this.seekSlider[0].max * 100 + '%');
        },
        displayBufferedAmount() {
            const bufferedAmount = Math.floor(this.player[0].buffered.end(this.player[0].buffered.length - 1));
            this.playerContainer.css('--buffered-width', `${(bufferedAmount / this.seekSlider[0].max) * 100}%`);
        },
        displayDuration() {
            let audio_duration = this.player[0].duration;
            let current_time = this.player[0].currentTime

            this.audioDuration = convertMilliSecondsToIsoFormat(audio_duration);
            this.currentTime = convertMilliSecondsToIsoFormat(current_time);
            this.remainingTime = convertMilliSecondsToIsoFormat(audio_duration - current_time);
        },
        audioPlayerClicked() {
            if (!this.isPlaying){
                this.player[0].play();
                this.isPlaying = true
                // window.requestAnimationFrame(this.whilePlaying()) 
                this.whilePlaying()
            } else if (this.isPlaying) {
                this.player[0].pause();
                this.isPlaying = false;
                // window.cancelAnimationFrame(this.raf)
            }
        },
        whilePlaying() {
          // setTimeout(()=> {
            // console.log(typeof(this.whilePlaying));
          this.updateSliderVal();
          // this.raf = window.requestAnimationFrame(this.whilePlaying());
          // }, 500); 


        },
        updateSliderVal() {
          this.seekSlider[0].value = Math.floor(this.player[0].currentTime);
          this.playerContainer.css('--seek-before-width', `${this.seekSlider[0].value / this.seekSlider[0].max * 100}%`);
        },
        updatePlayerVal() {
          this.player[0].currentTime = this.seekSlider[0].value;
          if (!this.player.paused){
            // window.requestAnimationFrame(this.whilePlaying())
            this.whilePlaying()
          }
        },
        updateSeekTime() {
            this.seekSlider.attr('value', Math.floor(this.player[0].currentTime));
            const updateSliderMax = () => { this.seekSlider.attr('max', Math.floor(this.player[0].duration)) }

            if (this.player.readyState > 0) {
                this.displayDuration();
                updateSliderMax();
            } else {
                this.player.on('loadedmetadata', () => {
                    this.displayDuration();
                    updateSliderMax();
                });
            }
        },
        animateSlider() {
           if(!this.player[0].paused) {
              window.cancelAnimationFrame(this.raf)
            }
        }
    },

    mounted() {
          jQuery(".preview").css("height", jQuery(window).height() + "px");
          this.handleMediaSessionState();
          this.initializePlayer(); 
          this.setAudioListers();
          this.setSeekListers();
    }
}
</script>


<style>
.player-actions input{
  width: 81% !important;
  margin-left: 1rem !important;
}
@media only screen and (max-width: 360px){
  .audio__container {
      height: 18rem !important;
      margin: 12rem auto !important;
  }
  .player {
     padding: 1rem 0.2rem 0.8rem 0.2rem !important;
  }
  .player-actions input{
    width: 100% !important;
    margin-left: 0.5rem !important;
  }
  .artist_details{
    margin-left: 0;
  }
  .audio_text{
    margin-left: 0;
  }
  .title{
    width: 5rem !important;
  }
  .artist{
    font-size: 0.5rem !important;
    line-height: 1.58;
  }
}
@media only screen and (min-width: 360px) and (max-width: 399){
  .audio__container {
      height: 20rem;
      margin: 4rem auto;
  }
  .title{
    width: 5rem !important;
  }
  .artist{
    line-height: 1.58;
  }
}
@media only screen and (max-width: 400px){
  .audio__container {
    height: 22rem;
    margin: 13rem auto 10rem auto;
  }
  .title{
    width: 5rem !important;
    font-size: 0.5rem !important;
  }
  .artist{
    font-size: 0.5rem !important;
    line-height: 1.58;
  }
}
@media only screen and (min-width: 401px) and (max-width: 440px){
  .audio__container {
      height: 28rem !important;
      margin: 14rem auto;
  }
  .player-actions{
    margin: 0.4rem 0 !important;
  }
}
@media only screen and (min-width: 441px){
  .audio__container {
    height: 50%;
    margin: 15rem auto 0 auto;

  }
  .player-actions{
    margin: 0.4rem 0 !important;
  }
  .player-actions input{
    margin-left: 1.5rem !important;
  }
}
@media (max-height : 300px){ 
  .player{
    padding-top: 0;
    padding-bottom: 0;
  }
}
.preview{
    align-items: center;
    flex-direction: column;
    justify-content: flex-start;
    display: flex;
}
.audio__container{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 80%;
  border-radius: 0.3rem;
  background-color: #dee7f6;
}
.player{
    width: 100%;
    height: auto;
    padding: 1rem 3rem 0.8rem 1rem;
    box-shadow: 0 0.07rem 0.2rem 0 rgba(0, 0, 0, 0.31);
    background-color: #fff;
}
.audio_thumb{
    height: 80%;
    display: flex;
    justify-content: center;
    height: 80%;
    width: fit-content;
    margin: 0 auto;
}
.audio_thumb img {
  width: 50%;
}
.player-actions{
    display: flex;
    flex-direction: row;
    align-items: center;
}
.artist_details{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-left: 2.5rem;
}
.timer{
    display: flex;
    justify-content: space-between;
    margin-left: 12%;
}
.audio_text{
  height: 0.8rem;
  font-family: SFUIDisplay;
  font-size: 0.7rem;
  font-weight: 500;
  text-align: left;
  color: #6b6b6b;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.title{
  width: 7rem;
  height: 1rem;
  opacity: 0.82;
  font-family: SFUIDisplay;
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.58;
  text-align: left;
  color: #4b4b4b;
}
.artist{
  height: 0.9rem;
  font-family: SFUIDisplay;
  font-size: 0.7rem;
  font-weight: 500;
  line-height: 1.82;
  text-align: left;
  color: #6b6b6b;
}
.duration {
  height: 0.9rem;
  font-family: SFUIDisplay;
  font-size: 0.7rem;
  font-weight: 500;
  line-height: 1.82;
  text-align: left;
  color: #6b6b6b;
}
.time{
    opacity: 0.52;
}
.play-btn img{
  width: 1.8rem;
  height: 1.8rem;
}


input[type="range"] {
  position: relative;
  -webkit-appearance: none;
  width: 100%;
  margin: 0;
  padding: 0;
  height: 1.3rem;
  float: left;
  outline: none;
}
input[type="range"]::-webkit-slider-runnable-track {
    width: 100%;
    height: 0.2rem;
    cursor: pointer;
    background: linear-gradient(to right, rgba(0, 125, 181, 0.6) var(--buffered-width), rgba(0, 125, 181, 0.2) var(--buffered-width));
}
input[type="range"]::before {
  position: absolute;
  content: "";
  top: 0.5rem;
  left: 0;
  width: var(--seek-before-width);
  height: 0.2rem;
  background-color: #007db5;
  cursor: pointer;
}
input[type="range"]::-webkit-slider-thumb {
  position: relative;
  -webkit-appearance: none;
  box-sizing: content-box;
  border: 0.07rem solid #007db5;
  height: 1.07rem;
  width: 1.07rem;
  border-radius: 50%;
  background-color: #fff;
  cursor: pointer;
  margin: -0.5em 0 0 0;
}
input[type="range"]:active::-webkit-slider-thumb {
  transform: scale(1.2);
  background: #007db5;
}
input[type="range"]::-moz-range-track {
  width: 100%;
  height: 0.2rem;
  cursor: pointer;
  background: linear-gradient(to right, rgba(0, 125, 181, 0.6) var(--buffered-width), rgba(0, 125, 181, 0.2) var(--buffered-width));
}
input[type="range"]::-moz-range-progress {
  background-color: #007db5;
}
input[type="range"]::-moz-focus-outer {
  border: 0;
}
input[type="range"]::-moz-range-thumb {
  box-sizing: content-box;
  border: 0.07rem solid #007db5;
  height: 1.07rem;
  width: 1.07rem;
  border-radius: 50%;
  background-color: #fff;
  cursor: pointer;
}
input[type="range"]:active::-moz-range-thumb {
  transform: scale(1.2);
  background: #007db5;
}
input[type="range"]::-ms-track {
  width: 100%;
  height: 0.2rem;
  cursor: pointer;
  background: transparent;
  border: solid transparent;
  color: transparent;
}
input[type="range"]::-ms-fill-lower {
  background-color: #007db5;
}
input[type="range"]::-ms-fill-upper {
  background: linear-gradient(to right, rgba(0, 125, 181, 0.6) var(--buffered-width), rgba(0, 125, 181, 0.2) var(--buffered-width));
}
input[type="range"]::-ms-thumb {
  box-sizing: content-box;
  border: 0.07rem solid #007db5;
  height: 1.07rem;
  width: 1.07rem;
  border-radius: 50%;
  background-color: #fff;
  cursor: pointer;
}
input[type="range"]:active::-ms-thumb {
  transform: scale(1.2);
  background: #007db5;
}
</style>